import { FlightSegment } from '@/src/types/itinerary'
import { logError } from '../logError'

export const checkNextDayArrival = (
    segments: FlightSegment[],
    formatDate: (date: string, format?: string) => string
) => {
    const firstDepartureDate = segments[0] || {}
    const lastArrivalDate = segments[segments.length - 1] || {}

    let arrivalDateNumber = ''
    let departureDateNumber = ''

    try {
        if (lastArrivalDate.formattedArrivalDateTime) {
            arrivalDateNumber = formatDate(lastArrivalDate.formattedArrivalDateTime, 'DD')
        }
        if (firstDepartureDate.formattedDepartDateTime) {
            departureDateNumber = formatDate(firstDepartureDate.formattedDepartDateTime, 'DD')
        }
        return arrivalDateNumber !== departureDateNumber
    } catch (e) {
        logError('checkNextDayArrival', e)
        return false
    }
}
